var _path, _line, _line2, _line3, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 2.05391H5C3.23269 2.05391 1.8 3.4866 1.8 5.25391V17.2539C1.8 19.0212 3.23269 20.4539 5 20.4539H17C18.7673 20.4539 20.2 19.0212 20.2 17.2539V5.25391C20.2 3.4866 18.7673 2.05391 17 2.05391ZM5 0.253906C2.23858 0.253906 0 2.49248 0 5.25391V17.2539C0 20.0153 2.23858 22.2539 5 22.2539H17C19.7614 22.2539 22 20.0153 22 17.2539V5.25391C22 2.49248 19.7614 0.253906 17 0.253906H5Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.880005,
    y1: 6.39395,
    x2: 21.12,
    y2: 6.39395,
    stroke: "black",
    strokeWidth: 1.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.46571,
    y1: 6.38487,
    x2: 4.6659,
    y2: 0.958188,
    stroke: "black",
    strokeWidth: 1.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15.4476,
    y1: 6.39561,
    x2: 11.5898,
    y2: 0.886153,
    stroke: "black",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.18 13.2279C14.8467 13.6128 14.8467 14.575 14.18 14.9599L9.91999 17.4194C9.25332 17.8043 8.41999 17.3232 8.41999 16.5534L8.41999 11.6344C8.41999 10.8646 9.25333 10.3835 9.91999 10.7684L14.18 13.2279Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.c18f8701976b2e63bc4ff1ee3ec9c52c.svg";
export { ForwardRef as ReactComponent };